// Maison Dodji — Project Space registry.
//
// File-driven authoring per approved doctrine.
// Each Space is an ES module. Registered here by opaque token → module.
//
// Tokens are:
//   • not linked from any public surface
//   • not referenced in sitemap or robots
//   • non-guessable (UUID or long opaque slug)
//
// Adding a Space = adding one file below + one line in the registry + one deploy.
// This friction is intentional: opening a Space is an editorial act, not a form.

import qaFixtureAlpha from "./qa-fixture-alpha";

export const SPACES = {
  // Private QA fixture — never linked, never a real client.
  // Used only for technical validation of the Space infrastructure.
  "qa-fixture-alpha": qaFixtureAlpha,
};

export const getSpace = (token) => SPACES[token] || null;
